module.exports = "/img/_/_/_/assets/images/creeper/book/common//3.jpg?532aec2a38e9d8507f416eae1dbde4ae";